<template>
    <div data-testid="compose-message-no-providers" class="question" v-html="$translate('message.noProvidersToMessage')"></div>
</template>

<script>
    export default {
        name: 'ComposeMessageNoProviders',
    };
</script>
